import { gql } from '@apollo/client';

export const GET_PRONOUNS_TASKS = gql`
query Pronouns($assignmentId: Int!) {
  pronouns(assignment_id: $assignmentId) {
    status_id
    task_id
    task_pronouns_id
    source_text
    is_bookmarked
    translations {
      pronoun_text
    }
    notes {
      id
      text
      createdAt
      updatedAt
      userDetails {
        userId
        name
        role
      }
    }
  }
}
`;

export const CREATE_PRONOUNS_TRANSLATION = gql`
mutation CreateOrUpdatePronounTranslation($pronouns: CreateOrUpdatePronounTranslationInput!) {
  createOrUpdatePronounTranslation(pronouns: $pronouns) {
    pronoun_text
  }
}`;

export const QUERY_TASKS_PER_ASSIGNMENT = gql`
  query TasksPerAssignment($assignmentId: Int!) {
    tasksPerAssignment(assignment_id: $assignmentId) {
      id
      task_type_id
      task_data_id
      status_id
      project_id
      assignment_id
      is_bookmarked
      data {
        ... on TaskTranslationData {
          id
          source_sentence_id
          book_id
          book_title
          chapter_id
          chapter_title
          source_sentence_number
          source_sentence_text
          translated_sentence_text
          translated_sentence_id
        }
        ... on TaskPeerReviewData {
          id
          source_sentence {
            id
            sentence_number
            sentence_text
            chapter_id
            book_id
            book_title
            chapter_title
          }
          translated_sentence {
            id
            sentence_text
          }
        }
      }
      notes {
      id
      text
      createdAt
      userDetails {
        userId
        name
        role
      }
    }
    }
  }
`;
export const QUERY_ASSIGNMENT_DETAIL = gql`
  query AssignmentDetails($assignment_id: Int!) {
    assignmentDetails(assignment_id: $assignment_id) {
      assignment_id
      assignment_name
      module_name
      level_name
      level_id
      module_id
      assignment_type_id
      status_id
      project_id
      isBlocked
    }
  }
`;
export const MUTATION_UPDATE_ASSIGNMENT = gql`
  mutation UpdateAssignment($id: Int!, $assignment: UpdateAssignmentInput!) {
    updateAssignment(id: $id, assignment: $assignment) {
      id
    }
  }
`;
